import PropTypes from "prop-types";
import { Box } from "@mui/material";

export const TutorialImage = ({ info }) => {
  // Image properties
  const imageProp = info.imageProp ?? {
    maxWidth: 100,
    align: "center",
  };

  // The component
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        alignSelf: "stretch",
        px: 2,
        display: "flex",
        alignItems: imageProp.align,
        justifyContent: "center",
      }}
    >
      <Box
        component="img"
        src={info.url}
        alt={`Tutorial image ${info.id + 1}`}
        sx={{
          display: "block",
          width: "auto",
          height: "auto",
          maxWidth: `${imageProp.maxWidth}%`,
          maxHeight: "100%",
          minWidth: 0,
          minHeight: 0,
          borderRadius: 2,
          objectFit: "contain",
        }}
      />
    </Box>
  );
};

TutorialImage.propTypes = {
  info: PropTypes.object.isRequired,
};
